import type {HideableValue, RichTextContent} from '@wix/devzai-utils-common';
import {hideableValueCreateHidden} from '@wix/devzai-utils-common';
import type {WixMediaResource} from '@wix/devzai-common-wix';
import type {DoppeDtoAction} from '../doppe-dto-action';
import {DoppePageLockBackgroundMode} from '../doppe-page-lock-background-mode';
import {DoppePageLockPreviewImageAspectRatio} from '../doppe-page-lock-preview-image-aspect-ratio';

export interface DoppePageLockSettings {
    lockActions: DoppeDtoAction<any>[];
    enableLock: boolean;
    customPreviewContent: boolean;
    customLockPreviewButtonText: HideableValue<string>;
    customLockPreviewTitle: HideableValue<string>;
    customLockPreviewDescription: HideableValue<RichTextContent>;
    customLockPreviewMedia: WixMediaResource | null;
    customLockPreviewMediaAspectRatio: DoppePageLockPreviewImageAspectRatio;
    backgroundMode: DoppePageLockBackgroundMode;
}

export function doppePageLockSettingsGetDefault(): DoppePageLockSettings {
    return {
        lockActions: [],
        enableLock: false,
        customLockPreviewTitle: '',
        customLockPreviewDescription: '',
        customLockPreviewMedia: null,
        customLockPreviewButtonText: hideableValueCreateHidden(''),
        customPreviewContent: false,
        customLockPreviewMediaAspectRatio: DoppePageLockPreviewImageAspectRatio.Ratio4By5,
        backgroundMode: DoppePageLockBackgroundMode.Blur,
    };
}

export function doppePageLockSettingsResolve(
    lockSettings: DoppePageLockSettings | undefined
): DoppePageLockSettings {
    if (lockSettings === undefined) {
        return doppePageLockSettingsGetDefault();
    }

    return {
        ...doppePageLockSettingsGetDefault(),
        ...lockSettings,
    };
}

export function doppePageIsLockEnabled(lockSettings: DoppePageLockSettings | null | undefined): boolean {
    return lockSettings?.enableLock ?? false;
}

export function doppePageIsLockActive(lockSettings: DoppePageLockSettings | null | undefined): boolean {
    return doppePageIsLockEnabled(lockSettings) && doppePageHasLockAction(lockSettings);
}

export function doppePageHasLockAction(lockSettings: DoppePageLockSettings | null | undefined): boolean {
    return (lockSettings?.lockActions.length ?? 0) > 0;
}
